import { render } from "./UnresolvedTickets.vue?vue&type=template&id=3cbae39f&ts=true"
import script from "./UnresolvedTickets.vue?vue&type=script&lang=ts"
export * from "./UnresolvedTickets.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__